import React from 'react';
import './statcard.css';

const StatCard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  icon, 
  color = 'primary',
  size = 'medium',
  loading = false 
}) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000000) {
        return `$${(val / 1000000).toFixed(1)}M`;
      } else if (val >= 1000) {
        return `$${(val / 1000).toFixed(0)}K`;
      }
      return `$${val.toLocaleString()}`;
    }
    return val;
  };

  const getTrendIcon = (trendValue) => {
    if (trendValue > 0) return '↗';
    if (trendValue < 0) return '↘';
    return '→';
  };

  const getTrendColor = (trendValue) => {
    if (trendValue > 0) return 'success';
    if (trendValue < 0) return 'danger';
    return 'muted';
  };

  return (
    <div className={`jo-xyz-demo-stat-card jo-xyz-demo-stat-card--${size} jo-xyz-demo-stat-card--${color} ${loading ? 'jo-xyz-demo-stat-card--loading' : ''}`}>
      <div className="jo-xyz-demo-stat-card__header">
        <div className="jo-xyz-demo-stat-card__icon">
          {icon}
        </div>
        <div className="jo-xyz-demo-stat-card__title">
          {title}
        </div>
      </div>

      <div className="jo-xyz-demo-stat-card__content">
        <div className="jo-xyz-demo-stat-card__value">
          {loading ? (
            <div className="jo-xyz-demo-stat-card__skeleton" />
          ) : (
            formatValue(value)
          )}
        </div>

        {subtitle && (
          <div className="jo-xyz-demo-stat-card__subtitle">
            {subtitle}
          </div>
        )}

        {trend !== undefined && !loading && (
          <div className={`jo-xyz-demo-stat-card__trend jo-xyz-demo-stat-card__trend--${getTrendColor(trend)}`}>
            <span className="jo-xyz-demo-stat-card__trend-icon">
              {getTrendIcon(trend)}
            </span>
            <span className="jo-xyz-demo-stat-card__trend-value">
              {Math.abs(trend)}%
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
